/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";
import { exists } from "utils/empty-exists";

const TabContentDisplay = (props) => {
    
    const { tab } = props;
    const { richtext } = tab || {};
    const hasContent = exists(richtext);
    
    return (
        <>
            {!hasContent &&
                <h4 style={{ textAlign: "center", paddingTop: "2em", color: "#cecece" }}>
                    Click Edit to start adding tab content
                </h4>
            }
            {hasContent &&
                <RichTextPreview richtext={richtext} />
            }
        </>
    );
};

TabContentDisplay.displayName = "TabContentDisplay";
export { TabContentDisplay };
